<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    class="fill-current inline-block"
    :class="[width, height]"
    viewBox="0 0 76.617 80"
  >
    <defs>
      <linearGradient id="linear-gradient" y1="0.5" x2="1" y2="0.5" gradientUnits="objectBoundingBox">
        <stop offset="0" stop-color="#de4551" stop-opacity="0" />
        <stop offset="1" stop-color="#de4551" />
      </linearGradient>
    </defs>
    <g id="Group_266" data-name="Group 266" transform="translate(-10.824 0)">
      <g id="Group_265" data-name="Group 265" transform="translate(11.605 0)">
        <g id="Group_264" data-name="Group 264" transform="translate(0 0)">
          <g id="Group_254" data-name="Group 254" transform="translate(4.603)">
            <path
              id="Path_892"
              data-name="Path 892"
              d="M53.385,5.974C32.24,24.652,59.453,42.757,56.861,63.166c-1.152,9.074,2.508,17.748,14.485,16.757,14.6-1.208,9.3-15.189,12.354-24.5,5.259-16.016,37.614-12.275,24.2-36.945C99.343,2.738,67.939-6.882,53.385,5.974Z"
              transform="translate(-45.28 0)"
              fill="url(#linear-gradient)"
            />
          </g>
          <g id="Group_263" data-name="Group 263" transform="translate(0 5.485)">
            <path
              id="Path_893"
              data-name="Path 893"
              d="M89.935,118.38l-18.15-18.15a25.828,25.828,0,0,0,4.763-9.942h8.765a1.562,1.562,0,0,0,1.563-1.562V80.006a1.562,1.562,0,0,0-1.562-1.562H76.57a25.938,25.938,0,0,0-50.524,0h-8.66a1.562,1.562,0,0,0-1.562,1.563v8.719a1.562,1.562,0,0,0,1.563,1.563h8.682A25.935,25.935,0,0,0,67.218,104.8l18.151,18.151a3.229,3.229,0,1,0,4.567-4.567Z"
              transform="translate(-15.824 -54.751)"
              fill="#383838"
              opacity="0.1"
              style="isolation: isolate"
            />
            <g id="Group_261" data-name="Group 261">
              <path
                id="Path_894"
                data-name="Path 894"
                d="M354.536,312.675a3.229,3.229,0,0,1-4.567,0l-20.544-20.544,4.567-4.567,20.544,20.544a3.229,3.229,0,0,1,0,4.567Z"
                transform="translate(-280.425 -248.117)"
                fill="#fff"
              />
              <path
                id="Path_895"
                data-name="Path 895"
                d="M386.857,348.933l4.566-4.566,1.988,1.988-4.566,4.566Z"
                transform="translate(-328.883 -296.045)"
                fill="#f0324c"
              />
              <path
                id="Path_896"
                data-name="Path 896"
                d="M329.356,291.424l4.566-4.566,7.18,7.18-4.566,4.566Z"
                transform="translate(-280.367 -247.522)"
                fill="#f0324c"
              />
              <g id="Group_256" data-name="Group 256" transform="translate(9.553)">
                <circle
                  id="Ellipse_261"
                  data-name="Ellipse 261"
                  cx="25.931"
                  cy="25.931"
                  r="25.931"
                  transform="translate(0)"
                  fill="#fff"
                />
                <circle
                  id="Ellipse_262"
                  data-name="Ellipse 262"
                  cx="20.312"
                  cy="20.312"
                  r="20.312"
                  transform="translate(5.618 5.506)"
                  fill="#f0324c"
                />
                <g id="Group_255" data-name="Group 255" transform="translate(5.962 5.857)">
                  <path
                    id="Path_897"
                    data-name="Path 897"
                    d="M144.443,127.229c.262-.26,18.913-18.88,27.939-27.967a20.424,20.424,0,0,0-5.115-5.593L138.833,122.1a20.419,20.419,0,0,0,5.61,5.126Z"
                    transform="translate(-135.129 -90.376)"
                    fill="#fff"
                  />
                  <path
                    id="Path_898"
                    data-name="Path 898"
                    d="M138.862,72.592c-2.018,2-17.852,17.786-23.736,23.687a20.154,20.154,0,0,0,1.044,3.668l26.317-26.317A20.14,20.14,0,0,0,138.862,72.592Z"
                    transform="translate(-115.126 -72.592)"
                    fill="#fff"
                  />
                </g>
              </g>
              <path
                id="Path_899"
                data-name="Path 899"
                d="M85.312,174.582H17.387a1.562,1.562,0,0,1-1.562-1.562V164.3a1.562,1.562,0,0,1,1.563-1.562H85.312a1.562,1.562,0,0,1,1.563,1.563v8.719A1.562,1.562,0,0,1,85.312,174.582Z"
                transform="translate(-15.824 -142.795)"
                fill="#fff"
              />
              <path
                id="Path_900"
                data-name="Path 900"
                d="M393.587,162.738h-12.4v11.844h12.4a1.562,1.562,0,0,0,1.563-1.562V164.3A1.562,1.562,0,0,0,393.587,162.738Z"
                transform="translate(-324.099 -142.795)"
                fill="#f0324c"
              />
              <g id="Group_260" data-name="Group 260" transform="translate(19.99 22.491)">
                <g id="Group_257" data-name="Group 257">
                  <path
                    id="Path_901"
                    data-name="Path 901"
                    d="M147.031,185.794h0a.781.781,0,0,1-.7-.443l-2.49-5.184a.781.781,0,0,1,1.409-.676l1.786,3.719.929-1.933a.781.781,0,0,1,1.408.677l-1.633,3.4a.781.781,0,0,1-.7.443Z"
                    transform="translate(-143.76 -179.047)"
                    fill="#2f3042"
                  />
                  <path
                    id="Path_902"
                    data-name="Path 902"
                    d="M167.929,185.8a.781.781,0,0,1-.7-.443l-2.491-5.184a.781.781,0,1,1,1.408-.677l1.786,3.718,1.786-3.718a.781.781,0,1,1,1.408.677l-2.49,5.184A.781.781,0,0,1,167.929,185.8Z"
                    transform="translate(-161.392 -179.049)"
                    fill="#2f3042"
                  />
                </g>
                <g id="Group_258" data-name="Group 258" transform="translate(10.631)">
                  <path
                    id="Path_903"
                    data-name="Path 903"
                    d="M215.07,185.794h0a.781.781,0,0,1-.7-.443l-2.49-5.184a.781.781,0,0,1,1.409-.676l1.786,3.718.929-1.933a.781.781,0,0,1,1.408.677l-1.633,3.4A.781.781,0,0,1,215.07,185.794Z"
                    transform="translate(-211.798 -179.047)"
                    fill="#2f3042"
                  />
                  <path
                    id="Path_904"
                    data-name="Path 904"
                    d="M235.967,185.8a.781.781,0,0,1-.7-.443l-2.49-5.184a.781.781,0,1,1,1.408-.677l1.786,3.718,1.786-3.718a.781.781,0,1,1,1.408.677l-2.49,5.184a.78.78,0,0,1-.7.443Z"
                    transform="translate(-229.43 -179.049)"
                    fill="#2f3042"
                  />
                </g>
                <g id="Group_259" data-name="Group 259" transform="translate(21.262)">
                  <path
                    id="Path_905"
                    data-name="Path 905"
                    d="M283.109,185.794h0a.781.781,0,0,1-.7-.443l-2.49-5.184a.781.781,0,0,1,1.409-.676l1.786,3.719.929-1.933a.781.781,0,0,1,1.408.677l-1.633,3.4a.781.781,0,0,1-.7.443Z"
                    transform="translate(-279.837 -179.047)"
                    fill="#2f3042"
                  />
                  <path
                    id="Path_906"
                    data-name="Path 906"
                    d="M304.007,185.8a.781.781,0,0,1-.7-.443l-2.49-5.184a.781.781,0,1,1,1.408-.677l1.786,3.718,1.786-3.718a.781.781,0,1,1,1.408.677l-2.49,5.184a.781.781,0,0,1-.7.443Z"
                    transform="translate(-297.469 -179.049)"
                    fill="#2f3042"
                  />
                </g>
              </g>
            </g>
            <g id="Group_262" data-name="Group 262" transform="translate(6.192 0.663)">
              <path
                id="Path_907"
                data-name="Path 907"
                d="M167.157,417.936a.779.779,0,0,1-.553-.229l-1.719-1.719a.781.781,0,0,1,0-1.1l1.719-1.719a.781.781,0,0,1,1.1,0l1.719,1.719a.781.781,0,0,1,0,1.1l-1.719,1.719A.779.779,0,0,1,167.157,417.936Zm-.614-2.5.614.614.614-.614-.614-.614Z"
                transform="translate(-147.595 -354.563)"
                fill="#f0324c"
              />
              <path
                id="Path_908"
                data-name="Path 908"
                d="M422.315,95.1a.779.779,0,0,1-.552-.229l-1.719-1.719a.781.781,0,0,1,0-1.1l1.719-1.719a.781.781,0,0,1,1.1,0l1.719,1.719a.781.781,0,0,1,0,1.1l-1.719,1.719A.779.779,0,0,1,422.315,95.1Zm-.614-2.5.614.614.614-.614-.614-.614Z"
                transform="translate(-362.884 -82.168)"
                fill="#f0324c"
              />
              <path
                id="Path_909"
                data-name="Path 909"
                d="M224.2,406.268a.781.781,0,0,1-.781-.781.938.938,0,0,0-.937-.937.781.781,0,1,1,0-1.562.938.938,0,0,0,.938-.937.781.781,0,0,1,1.563,0,.938.938,0,0,0,.938.938.781.781,0,0,1,0,1.563.938.938,0,0,0-.937.938A.781.781,0,0,1,224.2,406.268Z"
                transform="translate(-195.722 -344.718)"
                fill="#f0324c"
              />
              <path
                id="Path_910"
                data-name="Path 910"
                d="M57.956,44.349a.781.781,0,0,1-.781-.781.938.938,0,0,0-.937-.937.781.781,0,1,1,0-1.562.938.938,0,0,0,.937-.937.781.781,0,1,1,1.563,0,.938.938,0,0,0,.938.938.781.781,0,1,1,0,1.563.938.938,0,0,0-.938.937A.781.781,0,0,1,57.956,44.349Z"
                transform="translate(-55.456 -39.349)"
                fill="#f0324c"
              />
              <path
                id="Path_911"
                data-name="Path 911"
                d="M391.114,44.349a.781.781,0,0,1-.781-.781.938.938,0,0,0-.937-.937.781.781,0,1,1,0-1.562.938.938,0,0,0,.937-.937.781.781,0,1,1,1.563,0,.938.938,0,0,0,.938.938.781.781,0,1,1,0,1.563.938.938,0,0,0-.937.937A.781.781,0,0,1,391.114,44.349Z"
                transform="translate(-336.558 -39.349)"
                fill="#f0324c"
              />
            </g>
          </g>
        </g>
        <path
          id="Path_912"
          data-name="Path 912"
          d="M405.087,183.084a2.765,2.765,0,0,0,1.334-.341l1.615,1.615a.781.781,0,0,0,1.105-1.1l-1.615-1.615a2.78,2.78,0,0,0-.473-3.3h0a2.78,2.78,0,1,0-1.966,4.745Zm-.861-3.64a1.217,1.217,0,0,1,1.721,0h0a1.219,1.219,0,0,1,0,1.721h0a1.217,1.217,0,0,1-1.721-1.722Z"
          transform="translate(-341.921 -149.786)"
          fill="#2f3042"
        />
      </g>
      <path
        id="Path_913"
        data-name="Path 913"
        d="M156.984,94.876A19.531,19.531,0,1,0,118.222,98.3h38.462a19.573,19.573,0,0,0,.3-3.419Z"
        transform="translate(-90.364 -63.572)"
        fill="none"
      />
      <path
        id="Path_914"
        data-name="Path 914"
        d="M139.073,238.34A19.563,19.563,0,0,0,158.3,222.228H119.842a19.563,19.563,0,0,0,19.231,16.112Z"
        transform="translate(-91.984 -187.505)"
        fill="none"
      />
      <path
        id="Path_915"
        data-name="Path 915"
        d="M86.269,89.609,68.6,71.936A26.718,26.718,0,0,0,72.94,62.85h8.154a2.346,2.346,0,0,0,2.344-2.344V51.787a2.346,2.346,0,0,0-2.344-2.344H67.106a21.095,21.095,0,0,0-40.033,0H22.832A25.291,25.291,0,0,1,31.458,36.4a24.883,24.883,0,0,1,15.632-5.447A25.223,25.223,0,0,1,69.982,45.673a.781.781,0,1,0,1.421-.649A26.789,26.789,0,0,0,47.089,29.389a26.431,26.431,0,0,0-16.6,5.786,26.85,26.85,0,0,0-9.27,14.269H13.168a2.346,2.346,0,0,0-2.344,2.344v8.719a2.346,2.346,0,0,0,2.344,2.344h8.071a26.852,26.852,0,0,0,9.247,14.178,26.716,26.716,0,0,0,32.442.584L80.6,95.28a4.01,4.01,0,0,0,5.672-5.671ZM47.089,36.57A19.564,19.564,0,0,1,65.451,49.444H28.727A19.565,19.565,0,0,1,47.089,36.57ZM13.168,61.287a.782.782,0,0,1-.781-.781V51.787a.782.782,0,0,1,.781-.781H81.094a.782.782,0,0,1,.781.781v8.719a.782.782,0,0,1-.781.781Zm52.25,1.563a19.532,19.532,0,0,1-36.657,0ZM62.675,75.84A25.154,25.154,0,0,1,31.458,75.8a25.293,25.293,0,0,1-8.6-12.954h4.248a21.092,21.092,0,0,0,39.968,0h4.249A25.3,25.3,0,0,1,62.675,75.84ZM85.164,94.175a2.448,2.448,0,0,1-3.462,0L64.167,76.64a26.768,26.768,0,0,0,3.459-3.465L85.164,90.714A2.451,2.451,0,0,1,85.164,94.175Z"
        transform="translate(0 -24.797)"
        fill="#2f3042"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: 'w-14'
    },
    height: {
      type: String,
      default: 'h-16'
    }
  }
}
</script>
